import { confirmRegistBizApiRequest, registerBizApiRequest } from '@guryou/api-client';

import { ActionStatus, buildActionType, NotificationType } from '../core';
import { CONFIRM_REGISTER_BIZ, NOTIFICATION, REGISTER_BIZ } from '../types';

const registerBizAction = formData => async dispatch => {
  dispatch({ type: buildActionType(REGISTER_BIZ, ActionStatus.START) });
  const response = await registerBizApiRequest(formData.name, formData.email, formData.password);

  if (response.data.register) {
    dispatch({ type: buildActionType(REGISTER_BIZ, ActionStatus.DONE) });
    dispatch({ type: NOTIFICATION, payload: { message: `Successfully signed up`, variant: NotificationType.Success } });
  } else {
    dispatch({ type: buildActionType(REGISTER_BIZ, ActionStatus.FAILED) });
    dispatch({
      type: NOTIFICATION,
      payload: { message: response.errors ? response.errors[0].message : 'Unknown error', variant: NotificationType.Error },
    });
  }
};

const confirmRegisterBizAction = code => async dispatch => {
  dispatch({ type: buildActionType(CONFIRM_REGISTER_BIZ, ActionStatus.START) });
  const response = await confirmRegistBizApiRequest(code);

  if (response.data.confirm) {
    dispatch({ type: buildActionType(CONFIRM_REGISTER_BIZ, ActionStatus.DONE) });
    dispatch({ type: NOTIFICATION, payload: { message: `Successfully activated`, variant: NotificationType.Success } });
  } else {
    dispatch({ type: buildActionType(CONFIRM_REGISTER_BIZ, ActionStatus.FAILED) });
    dispatch({
      type: NOTIFICATION,
      payload: { message: response.errors ? response.errors[0].message : 'Unknown code', variant: NotificationType.Error },
    });
  }
};

export { confirmRegisterBizAction, registerBizAction };
